import React from 'react';
import { useTheme } from '@material-ui/core';

export interface PromisScalePointProps {
  score: number;
}

export default function PromisScalePoint(props: PromisScalePointProps) {
  const { score } = props;

  const theme = useTheme();

  return (
    <polygon
      points="-6,0 6,0 0,6"
      transform={
        `translate(${62 + ((score - 20) / 60) * 271}, 25)`
      }
      fill={theme.palette.primary.main}
    />
  );
}
